import { sortOptionIndex, sortOptionsOrdered } from '../settings';

const getStringSearchParams = index => {
  const ids = sortOptionsOrdered.map(option => option.id);
  const [moved] = ids.splice(index, 1);
  ids.unshift(moved);
  return ids.join(', ');
};
export const sortedStringParams = index => getStringSearchParams(index || sortOptionIndex);
